<script>
import { globalStatus }  from "../../../../helpers/helper"
import ArizaModal from "./widgets/ariza_modal.vue";

export default {
  props:[
    "data"
  ],
  components: { ArizaModal },
  data() {
    return {
        list: {},
        isLoading: false,
        rows: [],
        type:null,
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `${params.firstRecordOnPage} - ${params.lastRecordOnPage} ( Toplam: ${params.totalRecords}) `,
      },
     
      columns: [
        {
          label: 'Arıza Tanımı',
          field: 'name',
          sortable: false,
          filterOptions: {
            enabled: true,
            filterDropdownItems: [ ],
          },
        },
        {
          label: 'Detay',
          field: 'content',
          sortable: false,
        }, 
        {
          label: 'Durumu',
          field: this.status,
          sortable: false,
          html:true
        },
        {
          label: 'Açılma Tarihi',
          field: 'created_at',
          sortable: false,
        },
      ],
    };
  }, 


  methods: {
    status(rowObj) {
      return globalStatus(rowObj.status);
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
      const { id } = this.$route.params
      const url = `/members/${id}/faults`
      return new Promise((resolve, reject) => {
          this.$http.post(url, this.serverParams)
            .then(res => {
              resolve({
                rows: res.data.data,
                totalRecords: res.data.total,
                pageLength: res.data.last_page,
                currentPage: res.data.current_page,
              })
            })
            .catch(error => {
              reject(error)
            })
        })
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    onSearch(params) {
      this.updateParams(params)
      this.loadItems()
    },
    create(){
       const { id } = this.$route.params
      const { tariff_group } = this.data
       this.list = id
       this.type = tariff_group
       this.$bvModal.show('ariza_modal')
    },
  },
};
</script>

<template>
    <div class="row">
      <ArizaModal 
      :subsId="list" 
      :type="type" 
      @loadItems="loadItems" />
      <div class="col-12">
        <vue-good-table
            mode="remote"
            :total-rows="totalRecords"
            :columns="columns"
            :rows="rows"
            @on-search="onSearch"
            :pagination-options="paginationOptions"
            :is-loading.sync="isLoading"
            @on-selected-rows-change="selectionChanged"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange">
            <template slot="loadingContent">
                <div>Yükleniyor</div>
            </template>
            <div slot="table-actions">
                <button 
                class="btn btn-success btn-sm" 
                style="margin-right:10px;margin-top:2px" 
                type="button" 
                @click="create()"
                >Yeni Arıza Kaydı Aç
                </button>
            </div>
        </vue-good-table>
      </div>
    </div>
</template>